<script>
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: {
            redirectSource: String,
            course: Object,
            promotionType: String
        },
        data() {
            return {
                form: new Form({
                    uuid: null,
                    id: this.course.id,
                    active_promotion_fee: this.course.membership_fee > 0,
                    promo_membership_fee: this.course.membership_fee,
                    promo_description: this.course.promo_description,
                    promotions: [],
                    course_id: this.course.id,
                    promotion_type: this.promotionType,
                    promotion_has_same_course_hours: true
                })
            }
        },
        computed: {
            filterPromotions() {
                let promotions = this.form.promotions.filter(i => {
                    return _.isNumber(i.lessons) && _.isNumber(i.people) && !_.isEmpty(i.price)
                })
                return promotions
            }
        },
        mounted() {
            this.updatePromotions()

            if (this.course.promotions.length > 0) {
                this.$set(this.form, 'promotions', this.course.promotions)
            } else {
                this.onAddPromotion();
            }

            this.$bus.$on('contracts_accepted', () => {
                location.href = route('courses.promotion.show', this.course.slug)
            });
        },
        methods: {
            updatePromotions() {
                this.$set(this.form, 'uuid', +new Date)
                this.form
                    .get(route('courses.promotions_by_id', this.course.id))
                    .then(({course}) => {
                        if (course.promotions.length > 0) {
                            this.$set(this.form, 'promotions', course.promotions)
                        }
                    })
            },
            onAddPromotion() {
                if (this.form.promotions.length < 3) {
                    let newPromotion = {
                        lessons: '',
                        people: '',
                        price: '',
                        lesson_type: ''
                    }
                    this.form.promotions.push(newPromotion)
                }
                return
            },
            onDeletePromotion(index) {
                this.form.promotions.splice(index, 1)
            },
            onSubmit() {
                this.form
                    .submit('post', route('courses.promotion', this.course.slug))
                    .then(response => {
                        if (!this.course.company.accept_payments) {
                            this.$bus.$emit('ask_for_contracts');
                        } else {
                            location.href = route('courses.promotion.show', this.course.slug)
                        }
                    })
                    .catch(error => {
                        $('html,body').animate({
                            scrollTop: $(".invalid-feedback:first").parent().offset().top - 90
                        }, 'fast')

                        window.alerts.error('Attenzione, controlla i campi segnati in rosso')
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/CoursePromotionForm.vue